import React from 'react';
import { motion } from 'framer-motion';
import { Ripple } from '../ui/magic/Ripple';

export const ContactSections: React.FC = () => {
  return (
    <div className="bg-gray-50">
      {/* Partnership Section */}
      <section className="relative py-16 bg-gray-50 overflow-hidden border-t border-slate-200">
        <Ripple mainCircleSize={260} numCircles={5} className="opacity-60" />
        {/* Full height vertical lines at container edges */}
        <div className="absolute inset-0 max-w-5xl mx-auto pointer-events-none">
          <div className="absolute left-0 top-0 bottom-0 w-px bg-slate-200"></div>
          <div className="absolute right-0 top-0 bottom-0 w-px bg-slate-200"></div>
        </div>
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-8"
          >
            <h2 className="text-3xl md:text-5xl text-slate-900 mb-6 font-medium">
              Bring Cura to the people you serve
            </h2>
            <p className="text-lg md:text-xl text-slate-700 font-medium max-w-3xl mx-auto">
              Whether you support seniors, caregivers, or community health programs, partnering with Cura is simple. We handle setup, onboarding, and support, so your organization can focus on its mission.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <a
              href="mailto:founders@mycura.org?subject=Partnership%20Inquiry"
              className="inline-flex items-center px-8 py-3 bg-black text-white rounded-full text-lg font-semibold hover:bg-gray-900 transition-colors duration-200 shadow-lg hover:shadow-xl button-animate"
            >
              Start a Partnership Conversation
              <svg className="w-5 h-5 ml-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </a>
          </motion.div>
        </div>
      </section>

      {/* Call Section */}
      <section className="relative py-16 bg-gray-50 overflow-hidden border-t border-slate-200">
        {/* Full height vertical lines at container edges */}
        <div className="absolute inset-0 max-w-5xl mx-auto pointer-events-none">
          <div className="absolute left-0 top-0 bottom-0 w-px bg-slate-200"></div>
          <div className="absolute right-0 top-0 bottom-0 w-px bg-slate-200"></div>
        </div>
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-8"
          >
            <h2 className="text-3xl md:text-5xl text-slate-900 mb-6 font-medium">
              Prefer talking? Let's set up a call
            </h2>
            <p className="text-lg md:text-xl text-slate-700 font-medium max-w-3xl mx-auto">
              Sometimes it's easier to have a conversation. Our founding team is happy to walk through how Cura can support your community and answer any questions.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <a
              href="mailto:founders@mycura.org?subject=Schedule%20a%20Call"
              className="inline-flex items-center px-8 py-3 bg-black text-white rounded-full text-lg font-semibold hover:bg-gray-900 transition-colors duration-200 shadow-lg hover:shadow-xl button-animate"
            >
              Schedule a Call
              <svg className="w-5 h-5 ml-3" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};
